module.exports = __webpack_public_path__ + "f91a2970c1abf154d3d46d06f4d94e4b.jpg";